import React from 'react';
import { Link } from 'react-router-dom';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'transparent';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
  pulse?: boolean;
  disabled?: boolean;
};
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  type = 'button',
  className = '',
  onClick,
  pulse = false,
  disabled = false
}: ButtonProps) {
  const baseStyles = 'font-medium rounded-md transition-all duration-300 transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100';
  const variantStyles = {
    primary: 'bg-primary hover:bg-primary-light text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-secondary hover:bg-secondary-light text-white shadow-lg hover:shadow-xl',
    outline: 'bg-transparent border-2 border-white text-white hover:bg-white/10',
    transparent: 'bg-transparent border-2 border-white text-white hover:bg-white/10'
  };
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3',
    lg: 'px-8 py-4 text-lg'
  };
  const pulseClass = pulse ? 'animate-pulse-slow' : '';
  const buttonClasses = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${pulseClass} ${className}`;
  if (href) {
    return <Link to={href} className={buttonClasses} data-id="element-297">
        {children}
      </Link>;
  }
  return <button type={type} className={buttonClasses} onClick={onClick} disabled={disabled} data-id="element-298">
      {children}
    </button>;
}